import React from 'react';
import Plot from 'react-plotly.js';


export default function CreatedAtGraph(props) {
    const products = props
    return (
        <div className="ContainerGraph">
            <Plot
                data={[{
                    type: 'bar',
                    x: products.map((e) => e.date),
                    y: products.map((e) => (e.sum_licensence_created_at)),
                }]}
                layout={{
                    width: 625,
                    height: 500,
                    autoscale: false,
                    title: 'Licenças criadas',
                    'xaxis': { 'tickformat': '%y-%b'},
                    font: {
                        family: '"Roboto","Helvetica","Arial",sans-serif',
                        size: 16,
                        color: '#7f7f7f'
                    }
                }}
                config={{
                    displayModeBar: true,
                    staticPlot: false,
                    rangemode: 'tozero',
                }}
            />
        </div>
    )
}